import React from 'react';
import PropTypes from 'prop-types';
var DisplayPageContext = /*#__PURE__*/React.createContext({
  displayPage: undefined
});
/**
 * Puts displayPage value into context for the page that is rendering this document.
 * This `Provider` is just a helper.
 * Display Page values are defined here:
 * https://github.com/NerdWallet/react-components/blob/4a067b440097a8fc91cddd1bda88a2c90cc9b180/components/banking-product-cta/src/banking-product-cta.jsx#L18
 */

var DisplayPageContextProvider = function DisplayPageContextProvider(_ref) {
  var displayPage = _ref.displayPage,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(DisplayPageContext.Provider, {
    value: {
      displayPage: displayPage
    }
  }, children);
};

DisplayPageContextProvider.propTypes = {
  displayPage: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
/**
 * Pulls displayPage value from context for the page that is rendering this document.
 * This `Consumer` is just a helper to log a warning if app hasn't wrapped document tree correctly.
 * It also provides a default value that the context doesn't define.
 * Display Page values are defined here:
 * https://github.com/NerdWallet/react-components/blob/4a067b440097a8fc91cddd1bda88a2c90cc9b180/components/banking-product-cta/src/banking-product-cta.jsx#L18
 */

var DisplayPageContextConsumer = function DisplayPageContextConsumer(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(DisplayPageContext.Consumer, null, function (_ref3) {
    var displayPage = _ref3.displayPage;

    if (!displayPage && process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('displayPage is required. Make sure to wrap <StructuredContent /> in a <DisplayPageContextProvider />. See https://github.com/NerdWallet/structured-content#usage-of-displaypagecontext');
    }

    return children({
      displayPage: displayPage || 'CONTENT'
    });
  });
};

DisplayPageContextConsumer.propTypes = {
  children: PropTypes.func.isRequired
};
export default DisplayPageContext;
export { DisplayPageContextProvider, DisplayPageContextConsumer };